import { createAlert } from "records/Alert";
import i18n from "i18n";
import { AxiosError } from "axios";

type ApiErrorResponse = {
	"@error"?: {
		"@message"?: string;
	};
};

const getErrorMessage = (error: AxiosError<ApiErrorResponse>) => {
	return error?.response?.data["@error"]?.["@message"];
};

const getErrorMessageOrDefault = (
	error: AxiosError<ApiErrorResponse>,
	defaultMsg?: string
): string => {
	return (
		getErrorMessage(error) ||
		defaultMsg ||
		i18n.t("alerts.genericError.description")
	);
};

const createErrorAlert = (
	response: AxiosError,
	error: string,
	keys?: { [k: string]: string }
) => {
	const errorMessage = getErrorMessage(response);
	return createAlert({
		title: i18n.t(`alerts.${error}.title`, keys),
		description:
			errorMessage !== undefined
				? `${i18n.t(`alerts.${error}.description`)}: ${errorMessage}`
				: i18n.t(`alerts.${error}.description`),
		status: "error",
	});
};

const getErrorAlert = (code: number | undefined, response: AxiosError) => {
	const errorMessage = getErrorMessage(response);
	let alert;
	switch (code) {
		case 403:
		case 404:
		case 408:
		case 503:
		case 500:
		case 409:
			alert = createAlert({
				title: i18n.t(`alerts.${code.toString()}.title`),
				status: "error",
				description:
					errorMessage !== undefined
						? errorMessage
						: i18n.t(`alerts.${code.toString()}.description`),
			});
			break;

		default:
			alert = createAlert({
				title: i18n.t("alerts.genericError.title"),

				status: "error",
				description:
					errorMessage !== undefined
						? `${i18n.t(
								"alerts.genericError.description"
						  )}: ${errorMessage}`
						: i18n.t("alerts.genericError.description"),
			});

			break;
	}

	return alert;
};

export {
	getErrorAlert,
	getErrorMessage,
	getErrorMessageOrDefault,
	createErrorAlert,
};
